// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"

export default class TeamMemberController extends AdvancedController {

  static targets = [ 
    // TODO: use or remove
    // "exampleTarget",
    "backside" , "toggle"
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
  }

  toggle(event) {
    if(this.backsideTarget.classList.contains('-show')){
      this.backsideTarget.classList.remove('-show');
      this.toggleTarget.classList.remove('-inverted');
      this.toggleTarget.querySelector('.plus').classList.remove('-hide');
      this.toggleTarget.querySelector('.close').classList.add('-hide');
    } else {
      this.backsideTarget.classList.add('-show')
      this.toggleTarget.classList.add('-inverted');
      this.toggleTarget.querySelector('.plus').classList.add('-hide');
      this.toggleTarget.querySelector('.close').classList.remove('-hide');
  }}

}
